import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=c1587904&scoped=true"
var script = {}
import style0 from "./SideBar.vue?vue&type=style&index=0&id=c1587904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1587904",
  null
  
)

export default component.exports